
import CloseButton from "../../../../../components/CloseButton";
import CustomCalendar from "./CustomCalendar";

/**
 * ── 변경사항 (ECHO 톤) ──
 * 1. 빠른 날짜 칩 추가 (오늘 / 내일 / 3일 후 / 1주 후 / 2주 후)
 * 2. "마감일 후 삭제" 토글에 켜짐/꺼짐 동작 설명 표시
 * 3. MUI Switch → ECHO 톤 커스텀 토글
 * 4. onClickPrev 추가, 하단 ws-bottom-bar
 */
const DateSelectionPage = ({
  onClose,
  onClickPrev,
  onClickNext,
  selectedDate,
  handleDateSelect,
  hideAfterClosed,
  setHideAfterClosed,
}) => {
  const quickDates = [
    { label: "오늘", days: 0 },
    { label: "내일", days: 1 },
    { label: "3일 후", days: 3 },
    { label: "1주 후", days: 7 },
    { label: "2주 후", days: 14 },
  ];

  const getQuickDate = (daysFromNow) => {
    const d = new Date();
    d.setDate(d.getDate() + daysFromNow);
    d.setHours(23, 59, 59, 999);
    return d;
  };

  const isQuickActive = (days) =>
    selectedDate?.toDateString() === getQuickDate(days).toDateString();

  return (
    <div
      
      style={{ position: "relative", width: "100%", display: "flex", flexDirection: "column", minHeight: 0, maxHeight: "calc(80vh - 62px)", overflow: "hidden" }}
    >
      <CloseButton onClick={onClose} />

      <div style={{ padding: "22px 22px 0" }}>
        <div className="ws-modal-title">마감일 선택</div>
        <p className="ws-modal-sub" style={{ marginBottom: "14px" }}>
          학생이 이 날짜까지 과제를 완료해야 합니다.
        </p>

        {/* 빠른 선택 */}
        <div style={{ display: "flex", gap: "5px", flexWrap: "wrap", marginBottom: "4px" }}>
          {quickDates.map(({ label, days }) => (
            <button
              key={days}
              className={`ws-seg-btn${isQuickActive(days) ? " active" : ""}`}
              onClick={() => handleDateSelect(getQuickDate(days))}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className="ws-scroll" style={{ flex: 1, minHeight: 0, overflowY: "auto", WebkitOverflowScrolling: "touch" }}>
        <CustomCalendar
          selectedDate={selectedDate}
          handleDateSelect={handleDateSelect}
        />

        {/* 마감일 후 삭제 */}
        <div style={{ padding: "0 22px 16px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              padding: "13px 16px",
              backgroundColor: "#F4F8F7",
              borderRadius: "13px",
            }}
          >
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  fontSize: "0.86rem",
                  fontWeight: 800,
                  color: "#0E141B",
                  letterSpacing: "-0.01em",
                }}
              >
                마감일 후 삭제
              </div>
              <div
                style={{
                  fontSize: "0.76rem",
                  color: "#7A8490",
                  marginTop: "2px",
                  lineHeight: 1.5,
                }}
              >
                {hideAfterClosed
                  ? "마감일이 지나면 학생 화면에서 과제가 사라집니다."
                  : "마감일이 지나도 학생이 계속 풀 수 있습니다."}
              </div>
            </div>
            {/* ECHO 토글 */}
            <div
              onClick={() => setHideAfterClosed(!hideAfterClosed)}
              style={{
                width: "46px",
                height: "27px",
                borderRadius: "999px",
                backgroundColor: hideAfterClosed ? "#00D9C0" : "#D6DEE0",
                position: "relative",
                cursor: "pointer",
                transition: "background-color .15s",
                flexShrink: 0,
              }}
            >
              <span
                style={{
                  position: "absolute",
                  top: "3px",
                  left: hideAfterClosed ? "22px" : "3px",
                  width: "21px",
                  height: "21px",
                  borderRadius: "50%",
                  backgroundColor: "#FFF",
                  boxShadow: "0 1px 3px rgba(14,20,27,.18)",
                  transition: "left .15s",
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="ws-bottom-bar">
        {onClickPrev && (
          <button className="ws-btn-prev" onClick={onClickPrev}>
            이전
          </button>
        )}
        <button className="ws-btn-next" onClick={onClickNext}>
          다음 · 학생 선택
        </button>
      </div>
    </div>
  );
};

export default DateSelectionPage;
